import { EntityKind, buildBusinessErrorFromError, } from '@mgdis/eu-domain';
class DemandesApprenantsRestAdapter {
    tenantId;
    restHttpAdapter;
    /**
     * API of demande financement.
     */
    constructor({ tenantId, restHttpAdapter }) {
        this.tenantId = tenantId;
        this.restHttpAdapter = restHttpAdapter;
    }
    /**
     * Call API: get demande apprenant by reference
     *
     * @param reference - reference
     * @returns demande apprenant
     */
    async getDemandeApprenant(reference) {
        try {
            const res = await this.restHttpAdapter.get(`/referentiel-financement/api/tenants/${this.tenantId}/private/demandes-apprenants/depot/${reference}`);
            return { response: res.data };
        }
        catch (error) {
            return {
                error: buildBusinessErrorFromError(error, { entityKind: EntityKind.DEMANDE_FINANCEMENT }),
            };
        }
    }
    /**
     * Call API: get demandes apprenants.
     */
    async searchDemandesApprenants(pagination, aggregations, filters, sources, fromReferentielFinancementBourse = true) {
        try {
            const res = await this.restHttpAdapter.post(`/referentiel-financement${fromReferentielFinancementBourse ? '-bourse' : ''}/api/tenants/${this.tenantId}/private/demandes-apprenants/search`, {
                from: pagination.from,
                size: pagination.size,
                aggregations,
                aideSearch: filters,
                type: 'AIDES_APPRENANTS',
                apprenants: true,
                sources: sources ?? [],
            });
            return { response: res.data };
        }
        catch (error) {
            return { error: buildBusinessErrorFromError(error, { entityKind: EntityKind.DEMANDE_FINANCEMENT }) };
        }
    }
    /**
     * Call API: count demandes apprenants.
     */
    async countDemandesApprenants(filters) {
        try {
            const res = await this.restHttpAdapter.post(`/referentiel-financement/api/tenants/${this.tenantId}/private/demandes-apprenants/count`, { type: 'AIDES_APPRENANTS', aideSearch: filters });
            return { response: res.data };
        }
        catch (error) {
            return {
                error: buildBusinessErrorFromError(error, { entityKind: EntityKind.DEMANDE_FINANCEMENT }),
            };
        }
    }
}
export { DemandesApprenantsRestAdapter };
//# sourceMappingURL=demandes-apprenants-rest.adapter.js.map